exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__menu___1qmPx{margin-top:1.5rem}.style__navLink___3rQ4z{text-transform:capitalize}.style__navLink___3rQ4z:hover{background:#e2e2e2}.style__activeNavLink___1GFMC{color:#fff!important;background:#2199e8;text-transform:capitalize}", "", {"version":3,"sources":["/./containers/locus/style.css"],"names":[],"mappings":"AAAA,qBACC,iBAAmB,CACnB,AAED,wBACC,yBAA2B,CAC3B,AAED,8BACC,kBAAoB,CACpB,AAED,8BACC,qBAAwB,AACxB,mBAAoB,AACpB,yBAA2B,CAC3B","file":"style.css","sourcesContent":[".menu {\n\tmargin-top: 1.5rem;\n}\n\n.navLink {\n\ttext-transform: capitalize;\n}\n\n.navLink:hover {\n\tbackground: #e2e2e2;\t\n}\n\n.activeNavLink {\n\tcolor: white !important;\n\tbackground: #2199e8;\n\ttext-transform: capitalize;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"menu": "style__menu___1qmPx",
	"navLink": "style__navLink___3rQ4z",
	"activeNavLink": "style__activeNavLink___1GFMC"
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!/data/www/SGDBackend-Nex2/~/postcss-loader!./containers/locus/style.css
// module id = 561
// module chunks = 0